import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware } from "redux";

const rootMiddleware = composeWithDevTools(applyMiddleware());

export default rootMiddleware;
